<template>
    <div class="card-container">
        <common-top-form :model="formModel" :show="false" @success="onSuccess"
                         :submitService="submitService" :submitData="submitData">
            <el-form-item label="机构简称">
                <el-select v-model="formModel.tatSimpleId">
                    <el-option
                        v-for="item in topTatSimpleNames"
                        :key="item.id"
                        :label="item.simpleName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="出账日期">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getList">
            <el-table-column prop="tatId" label="机构简称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outType" label="出账类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tranTime" label="出账时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="costAmt" label="花费金额（元）" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.costAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="balAmt" label="剩余金额（元）" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.balAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'

    import FinanceService from 'service/FinanceService'
    import OrganService from 'service/OrganService'
    import privateKey from 'service/constant/privateKey';
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'


    export default {
        name: "OutAccountDetail",
        components: {
            CommonTopForm, CommonTable
        },
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    time: ''
                },
                tableData: [],
                tatSimpleNames: [],
                topTatSimpleNames: [],
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                submitService:FinanceService.getOutComeDtl,
                params:{},
                page:{},
            }
        },
        mixins: [loadMixin, dialogMixin],
        mounted(){
            this.page = this.$refs.commonTable.page;
            this.getSimpleNames();
            this.getList();
        },
        computed:{
            submitData(){
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                this.params = {
                    userId:this.userId,
                    tatSimpleId:this.formModel.tatSimpleId,
                    startDate:this.formModel.time[0],
                    endDate:this.formModel.time[1],
                    current: this.page.currentPage,
                    size: this.page.pageSize,
                };

                if (this.formModel.time.length == 0) {
                    delete this.params.startDate;
                    delete this.params.endDate;
                }

                return this.params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId']),
        },
        methods:{
            getSimpleNames() {
                this.doLoad(OrganService.simpleNames, '', res => {
                    this.doCheck(res, res => {
                        this.tatSimpleNames = res.contents;
                        this.topTatSimpleNames = [...this.all, ...res.contents];
                    });
                }, '信息获取失败')
            },
            getList(){
                this.doLoad(FinanceService.getOutComeDtl, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result.rows;

                        this.page.currentPage = result.current;
                        this.page.pageSize = result.size;
                        this.page.total = result.total;
                        console.log('getOutComeDtl', this.tableData)
                    });
                }, '信息获取失败')
            },
            onSuccess(res){
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                    console.log('getOutComeDtl', this.tableData)
                });
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/OutAccountDetail.vue